// extracted by mini-css-extract-plugin
export default {"esgFiltersContainer":"esgFilters_esgFiltersContainer__d3Myb","collapsableComponent":"esgFilters_collapsableComponent__Uk1Mo"};